import { BehaviorSubject, combineLatest, Observable, of, map } from 'rxjs';
import { Inject, Injectable, Optional, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser, isPlatformServer } from '@angular/common';

import { IS_SERVER_BOT } from '../config/configs/web-common.config';

@Injectable({
  providedIn: 'root'
})
export class LazyLoadingService {
  private _firstUids: BehaviorSubject<string[]> = new BehaviorSubject([]);
  private _loadedUids: BehaviorSubject<string[]> = new BehaviorSubject([]);

  get firstUids(): Observable<string[]> {
    return this._firstUids.asObservable();
  }

  get canLazyLoad(): Observable<boolean> {
    return this.isForced
      ? of(false)
      : combineLatest([this._firstUids, this._loadedUids]).pipe(
        map(([firstUids, loadedUids]) => firstUids.every((uid) => loadedUids.includes(uid)))
      );
  }

  get isEnabled(): boolean {
    return isPlatformBrowser(this.platformId);
  }

  get isForced(): boolean {
    return isPlatformServer(this.platformId) && !this.isServerBot;
  }

  constructor(
    @Inject(PLATFORM_ID) private platformId: any,
    @Optional() @Inject(IS_SERVER_BOT) private isServerBot: boolean
  ) {}

  setFirstUids(uids: string[]): void {
    this._loadedUids.next([]);
    this._firstUids.next(uids);
  }

  setUidLoaded(uid: string): void {
    const loadedUids = this._loadedUids.getValue();
    this._loadedUids.next([...loadedUids, uid]);
  }
}
